const tour = (state = {
    active: false,
    activeStep: null,
    completed: false,
    started: false,
    rejected: false,
    stepsDecreased: 0
}, action) => {
    switch (action.type) {
        case 'TEAM_CHANGE':
            return {
                active: false,
                activeStep: null,
                completed: false,
                started: false,
                rejected: false,
                stepsDecreased: 0
            };

        case 'TOUR_START_REQUESTED':
            return Object.assign({}, state, {
                active: true,
                activeStep: action.payload.stepId || state.activeStep,
                completed: false,
                started: true,
                rejected: false,
                stepsDecreased: 0
            });

        case 'TOUR_REJECT_REQUESTED':
            return Object.assign({}, state, {
                rejected: true
            });

        case 'TOUR_STEP_CHANGE_REQUESTED':
            return Object.assign({}, state, {
                activeStep: action.payload.stepId,
                stepsDecreased: action.payload.decreaseSteps ? state.stepsDecreased + 1 : state.stepsDecreased
            });

        case 'TOUR_STEP_PAUSE_REQUESTED':
            return Object.assign({}, state, {
                activeStep: action.payload.nextStepId
            });

        case 'TOUR_STOP_REQUESTED':
            return Object.assign({}, state, {
                active: false
            });

        case 'TOUR_COMPLETE_REQUESTED':
            return Object.assign({}, state, {
                completed: true
            });

        default:
            return state;
    }
}

export default tour;
